import axios from "axios";

const baseUrl = "https://texttospeech.googleapis.com/v1beta1";

const ttsApi = axios.create({
  baseURL: baseUrl,
  headers: {
    "X-Goog-Api-Key": process.env.REACT_APP_GOOGLE_API_KEY,
    "Content-Type": "application/json; charset=utf-8",
  },
});

function applyEvadePhonemeIfNeeded(
  text: string,
  languageCode: string
): string | null {
  if (languageCode === "en") {
    return `<speak>${text.replace(
      /evade/g,
      '<phoneme alphabet="ipa" ph="ibeɪd">evade</phoneme>'
    )}</speak>`;
  }
  return null;
}

export async function fetchAudio(
  text: string,
  languageCode: string,
  voiceActor: string,
  speakingRate: number
): Promise<string> {
  const voiceParameters = {
    name: voiceActor,
    languageCode: languageCode,
  };

  const ssml = applyEvadePhonemeIfNeeded(text, languageCode);
  const audioConfig: Record<string, unknown> = {
    audioEncoding: "LINEAR16",
  };
  audioConfig["speakingRate"] = speakingRate;

  const parameters = {
    input: ssml == null ? { text } : { ssml },
    voice: voiceParameters,
    audioConfig,
  };

  const response = await ttsApi.post("/text:synthesize", parameters);
  const content = response.data.audioContent;
  if (content === undefined) {
    return Promise.reject("Wrong response");
  } else {
    return content;
  }
}
